import { logInTrackJS } from '@/errors/helpers'
import type { LoginAttemptResult } from '@/helpers/AuthExternal'
import { authenticationMethod, environment } from '@/helpers/Environment'
import store from '@/store/store'
import type VueRouter from 'vue-router'
import type { Route } from 'vue-router'

function isSFEC() {
  return authenticationMethod === 'sf_ecomm'
}

async function login(currentPath: string): Promise<LoginAttemptResult> {
  const sellerSlug = environment.seller?.slug
  const sellerPrefix = sellerSlug ? `/${sellerSlug}` : ''
  const fullPath = `${sellerPrefix}${currentPath}`

  const cartId = store.getters['Cart/cart']?.id

  const params = new URLSearchParams({
    redirect: fullPath,
    ...(cartId && { cart_id: cartId }),
  })

  const oauthEndpoint = '/api/sso/start'
  const oauthUrl = `${oauthEndpoint}?${params.toString()}`

  window.location.assign(oauthUrl)

  return { success: true }
}

function handleRedirectCallback(router: VueRouter, to: Route): LoginAttemptResult {
  const { auth_error: authError } = to.query

  if (!authError) return { success: true }

  logInTrackJS(`SFEC error: ${authError}`, Error(authError))

  return { success: false, error: Error('SFEC Authentication failed') }
}

export const sfec = {
  isSFEC,
  login,
  handleRedirectCallback,
}

if (window.Cypress) {
  window.__spyOn?.(sfec)
}

export type SFECClient = typeof sfec
